export const TestID = 'DatePickerCustomInputTestID';

export const DROPDOWN_ARROW_ICON_WIDTH = 20;
